// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tYtw","buttons":"Footer_buttons__2U3rk"};